<template>
  <div class="downloadhtml">
    <div class="downloadall">
      <div class="downloadhead">
        <div class="downloadheadtext">
          <p
            style="
              font-size: 18px;
              color: #275479;
              font-weight: bold;
              line-height: 30px;
            "
          >
            下载
          </p>
        </div>
      </div>
      <div class="downloadbody">
        <div class="downloadbodyhead">
          <div
            v-bind:class="[isActive.ac1 ? isclicklf : noclick]"
            @click="tongyongshow"
          >
            下载实盘通用版
          </div>
          <div
            :class="[isActive.ac2 || isActive.ac1 ? 'tapyinying' : 'putong']"
          ></div>
          <div
            v-bind:class="[isActive.ac2 ? isclickmid : noclick]"
            @click="ceshishow"
          >
            下载体验版
          </div>
          <div
            :class="[isActive.ac2 || isActive.ac3 ? 'tapyinying' : 'putong']"
          ></div>
          <div
            v-bind:class="[isActive.ac3 ? isclickrg : noclick]"
            @click="xuexishow"
          >
            学习资料
          </div>
        </div>
        <xuexizliao v-if="isActive.ac3"></xuexizliao>
        <tongyong v-if="isActive.ac1"></tongyong>
        <shiyong v-if="isActive.ac2"></shiyong>
      </div>
    </div>
    <wh7footer></wh7footer>
  </div>
</template>

<script>
import wh7footer from "./components/wh7/wh7footer.vue";
import shiyong from "./components/download/shiyong.vue";
import tongyong from "./components/download/tongyong.vue";
import xuexizliao from "./components/download/xuexizliao.vue";
export default {
  components: {
    tongyong,
    shiyong,
    wh7footer,
    xuexizliao,
  },
  data() {
    return {
      isclickrg: "isclickrg",
      noclick: "noclick",
      isclicklf: "isclicklf",
      isclickmid: "isclickmid",
      isActive: { ac1: true, ac2: false, ac3: false },
    };
  },
  watch:{
      '$route' (to, from) { 
		if(to.query.id != from.query.id){
		    this.id = to.query.id; // 把最新id赋值给定义在data中的id
			var pa = this.$route.query.id;
      if (pa == "true") {
        this.tongyongshow();
      } else if (pa == "false") {
        this.ceshishow();
      } else if (pa == "mid") {
        this.xuexishow();
      } else {
        this.tongyongshow();
      }
		}
	}
  },
  methods: {
    tongyongshow() {
      Object.keys(this.isActive).forEach((item) => {
        this.isActive[item] = false;
      });
      this.isActive.ac1 = true;
    },
    ceshishow() {
      Object.keys(this.isActive).forEach((item) => {
        this.isActive[item] = false;
      });
      this.isActive.ac2 = true;
    },
    xuexishow() {
      Object.keys(this.isActive).forEach((item) => {
        this.isActive[item] = false;
      });
      this.isActive.ac3 = true;
    },
  },
  created() {
    this.$nextTick(()=>{

      var pa = this.$route.query.id;
      if (pa == "true") {
        this.tongyongshow();
      } else if (pa == "false") {
        this.ceshishow();
      } else if (pa == "mid") {
        this.xuexishow();
      } else {
        this.tongyongshow();
      }
    })
  },
};
</script>

<style scoped>
.downloadhtml {
  min-width: 1400px;
  width: 100%;
  background-size: auto 1000px;
  min-height: 835px;
  z-index: 3;
  margin: 0 auto;
  background: #eeeff4;
}
.downloadall {
  background: url("../../assets/images/xiaz-bg.jpg") no-repeat top;
  background-size: 100% auto;
  min-width: 1400px;
  width: 100%;
}
.downloadhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.downloadheadtext {
  position: absolute;
  top: 100px;
}
.downloadbody {
  width: 1004px;
  margin: 0 auto;
  min-height: 100px;
}
.tapyinying {
  height: 52px;
  width: 1px;
  float: left;
  background: #e6e6e8;
}
.putong {
  background: url("../../assets/images/shuxian.jpg");
  height: 52px;
  width: 1px;
  float: left;
}
.isclickrg {
  background: #ffffff;
  width: 334px;
  height: 52px;
  text-align: center;
  font-size: 18px;
  float: left;
  line-height: 52px;
  color: #354066;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  filter: drop-shadow(0px 4px 2px #b9b9b8);
  box-shadow: inset 0px 5px 0px#364064;
  -webkit-box-shadow: inset 0px 5px 0px#364064;
  -ms-box-shadow: inset 0px 5px 0px#364064;
  -moz--box-shadow: inset 0px 5px 0px#364064;
}
.isclickmid {
  background: #ffffff;
  width: 334px;
  height: 52px;
  text-align: center;
  font-size: 18px;
  float: left;
  line-height: 52px;
  color: #354066;
  font-weight: bold;
  filter: drop-shadow(0px 4px 2px #b9b9b8);
  box-shadow: inset 0px 5px 0px#364064;
  -webkit-box-shadow: inset 0px 5px 0px#364064;
  -ms-box-shadow: inset 0px 5px 0px#364064;
  -moz--box-shadow: inset 0px 5px 0px#364064;
  cursor: pointer;
  letter-spacing: 1px;
}
.isclicklf {
  background: #ffffff;
  width: 334px;
  height: 52px;
  text-align: center;
  font-size: 18px;
  float: left;
  line-height: 52px;
  color: #354066;
  font-weight: bold;
  filter: drop-shadow(0px 4px 2px #b9b9b8);
  box-shadow: inset 0px 5px 0px#364064;
  -webkit-box-shadow: inset 0px 5px 0px#364064;
  -ms-box-shadow: inset 0px 5px 0px#364064;
  -moz--box-shadow: inset 0px 5px 0px#364064;
  cursor: pointer;
  letter-spacing: 1px;
}
.noclick {
  background: url("../../assets/images/xiaz-b.jpg");
  float: left;
  width: 334px;
  height: 52px;
  text-align: center;
  font-size: 18px;
  float: left;
  letter-spacing: 1px;
  line-height: 52px;
  color: #626e9d;
  font-weight: bold;
  cursor: pointer;
}
.downloadbodyhead {
  height: 52px;
}
</style>